import { cva } from 'class-variance-authority'

export const selectVariants = {
  trigger: cva([
    'py-xs',
    'px-s',
    'rounded-lg',
    'flex',
    'items-center',
    'justify-between',
    'w-full',
  ], {
    variants: {
      intent: {
        filled: [
          'bg-blurple-100',
          'hover:bg-blurple-50',
          'active:bg-blurple-200',
        ],
        outline: [
          'border',
          'border-blurple-500',
          'hover:outline',
          'hover:outline-1',
          'hover:outline-blurple-300',
          'hover:border-blurple-300',
          'active:bg-blurple-50',
        ],
      },
      open: {
        true: [],
        false: [],
      },
    },
  }),

  chevron: cva(['transition-transform', 'duration-200'], {
    variants: {
      open: {
        true: ['rotate-180'],
        false: [],
      },
    },
  }),
}
